import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import {
  CONDITION_COLORS,
  CONDITION_RATINGS,
  DESKTOP_BUILDER_CONDITION_RATINGS,
  type ConditionRating,
} from '@redevicer/shared'
import SelectionPickerGrid from './SelectionPickerGrid'

const BUILDER_CONDITION_ART: Record<
  (typeof DESKTOP_BUILDER_CONDITION_RATINGS)[number],
  string
> = {
  excellent: '/images/sell/bukle/puiki.png?v=13',
  good: '/images/sell/bukle/gera.png?v=13',
  fair: '/images/sell/bukle/vidutine.png?v=13',
  damaged: '/images/sell/bukle/pazeista.png?v=13',
}

interface ConditionPickerGridProps {
  value: string
  onChange: (value: ConditionRating) => void
  /** Desktop sell builder — 4-card Būklė row (TARGET mockup). */
  builderDesktop?: boolean
}

export default function ConditionPickerGrid({
  value,
  onChange,
  builderDesktop = false,
}: ConditionPickerGridProps) {
  const { t } = useTranslation()
  const ratings = builderDesktop ? DESKTOP_BUILDER_CONDITION_RATINGS : CONDITION_RATINGS
  const options = useMemo(
    () =>
      ratings.map((rating) => ({
        value: rating,
        color: CONDITION_COLORS[rating],
        title: t(`listing.condition.${rating}`),
        hint: t(`listing.condition.${rating}Hint`),
        ...(builderDesktop && rating in BUILDER_CONDITION_ART
          ? {
              imageSrc: BUILDER_CONDITION_ART[rating as keyof typeof BUILDER_CONDITION_ART],
              imageAlt: t(`listing.condition.${rating}`),
            }
          : {}),
      })),
    [t, ratings, builderDesktop],
  )

  return (
    <SelectionPickerGrid
      options={options}
      value={value}
      onChange={(next) => onChange(next as ConditionRating)}
      ariaLabel={t('listing.conditionLabel')}
    />
  )
}
